module.exports = {"bewizr-agenda":{"empty":{"title":"Keine Aktivitäten","detail":"Du hast keine Aktivitäten geplant."}}}